import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import Searchbar from "../../../../Components/Searchbar/Searchbar";
import WorkoutTable from "../../../../Components/Table/WorkoutTable";
import { Link } from "react-router-dom";
import CustomButton from "../../../../Components/Button/CustomButton";
import { GetWorkout } from "../../../../APIs/Function/Workout/WorkoutPlans/GetWorkout";
import { SearchDebouncing } from "../../../../APIs/Search/SearchDebouncing";

const WorkoutPlans = () => {
  const [workoutData, setWorkoutData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const handleWorkout = async () => {
    try {
      setLoading(true);
      let res = await GetWorkout();
      setWorkoutData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }
    try {
      await SearchDebouncing(4, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handleWorkout();
  }, []);
  return (
    <>
      <Box sx={{ boxSizing: "border-box", p: 2 }}>
        {/* searchbar */}
        <Box>
          <Searchbar placeholder={"search"} onChange={handleSearch} />
        </Box>
        {searched && searchData.length > 0 ? (
          <WorkoutTable
            setWorkoutData={setWorkoutData}
            workoutData={searchData}
            loadinga={loading}
            Column1={"#"}
            Column2={"Workout Cover"}
            column3={"Title"}
            Column4={"Action"}
          />
          ) : !searched ? (
          <WorkoutTable
            setWorkoutData={setWorkoutData}
            workoutData={workoutData}
            loadinga={loading}
            Column1={"#"}
            Column2={"Workout Cover"}
            column3={"Title"}
            Column4={"Action"}
          />
        ):""}
        <Box
          sx={{
            display: "flex",
            mt: "25px",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <Link to={"/addworkoutplans"}>
            <CustomButton
              sx={{
                width: "100%",
                bgcolor: "#31AEF4",
                "&:hover": {
                  bgcolor: "#31AEF4",
                },
              }}
            >
              ADD +
            </CustomButton>
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default WorkoutPlans;
